import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVerticalCircle24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFlipVerticalCircle24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M14.7 18.023A6.6 6.6 0 0 0 18.602 12a6.6 6.6 0 0 0-3.9-6.022V4.047A8.4 8.4 0 0 1 20.4 12l-.01.432a8.4 8.4 0 0 1-5.69 7.522zM11.113 2.1a.9.9 0 0 1 1.8 0v19.8a.901.901 0 0 1-1.8 0zm-7.5 9.468A8.405 8.405 0 0 1 9.3 4.045v1.934a6.6 6.6 0 0 0 0 12.044v1.932a8.4 8.4 0 0 1-5.699-7.954z"
            />
        </svg>
    );
}
export default memo(IconFlipVerticalCircle24);
